import React from 'react';
import gql from 'graphql-tag';
import { Query, Mutation } from 'react-apollo';
import {
  Table, Card, Container, Grid, Form, Button, Icon,
} from 'tabler-react';
import { Link } from '@curi/react-dom';
import AuthRedirect from '../auth/AuthRedirect';
import LocationSelect from './locationSelect';
import { makeSearchSettings } from '../archive/index';

const keywords = gql`
query userKeywords {
  userKeywords {
    name
    id
  }
}
`;

const alertEmails = gql`
query userKeywordAlerts {
  userKeywordAlerts {
    date
    id
  }
}
`;

const addKeywordQuery = gql`
mutation addKeyword($keyword: String!) {
  addKeyword(keyword: $keyword) {
    name
    id
  }
}
`;

const removeKeywordQuery = gql`
mutation removeKeyword($id: ID!) {
  removeKeyword(id: $id) {
    name
    id
  }
}
`;

const removeKeywordFromCache = (cache, { data: { removeKeyword } }) => {
  cache.writeQuery({
    query: keywords,
    data: { userKeywords: removeKeyword },
  });
};

const addKeywordToCache = async (cache, { data: { addKeyword } }) => {
  const { userKeywords } = cache.readQuery({ query: keywords });
  cache.writeQuery({
    query: keywords,
    data: { userKeywords: userKeywords.concat(addKeyword) },
  });
};

class AddKeyword extends React.Component {
  state = { keyword: '' }

  handleKeyPress = onAdd => (e) => {
    if (e.key === 'Enter') {
      this.handleClick(onAdd)();
    }
  }

  handleClick = onAdd => () => {
    this.setState({ keyword: '' });
    onAdd();
  }

  render() {
    return (
      <Mutation
        mutation={addKeywordQuery}
        variables={{ keyword: this.state.keyword }}
        update={addKeywordToCache}
      >
        {onAdd => (
          <Form.Group>
            <Form.InputGroup>
              <Form.Input
                placeholder="Add keyword . . ."
                onChange={({ target: { value } }) => this.setState({ keyword: value })}
                onKeyPress={this.handleKeyPress(onAdd)}
                value={this.state.keyword}
              />
              <Form.InputGroupAppend>
                <Button
                  RootComponent="button"
                  color="primary"
                  onClick={this.handleClick(onAdd)}
                >
              Add!
                </Button>
              </Form.InputGroupAppend>
            </Form.InputGroup>
          </Form.Group>
        )}
      </Mutation>
    );
  }
}

const Keyword = ({ id, name }) => {
  let url = '';
  try {
    url = btoa(makeSearchSettings({ searchTerm: name }));
  } catch (e) {
    console.log(e);
  }
  return (
    <Table.Row key={`${id}`}>
      <Table.Col>{name}</Table.Col>
      <Table.Col className="w-1">
        <div
          style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer',
          }}
        >
          <a href={`/archive?searchSettings=${url}`}>
            <Icon name="search" style={{ cursor: 'pointer' }} />
          </a>
        </div>
      </Table.Col>
      <Mutation
        mutation={removeKeywordQuery}
        variables={{ id }}
        update={removeKeywordFromCache}
      >
        {onRemove => (
          <Table.Col className="w-1">
            <div
              style={{
                display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer',
              }}
              onClick={onRemove}
            >
              <Icon name="x-square" style={{ cursor: 'pointer' }} />
            </div>
          </Table.Col>
        )}
      </Mutation>
    </Table.Row>
  );
};
const ItemList = ({ keywords }) => (
  <Table className="card-table table-vcenter">
    <Table.Header>
      <Table.ColHeader>Keyword</Table.ColHeader>
      <Table.ColHeader>Search</Table.ColHeader>
      <Table.ColHeader>Remove</Table.ColHeader>
    </Table.Header>
    <Table.Body>
      {keywords.slice(0).reverse().map(item => <Keyword key={item.id} {...item} />)}
    </Table.Body>
  </Table>
);

const AlertEmail = ({ alerts }) => (
  <Table className="card-table table-vcenter">
    <Table.Header>
      <Table.ColHeader>Alert Date</Table.ColHeader>
    </Table.Header>
    <Table.Body>
      {alerts.map(item => <Table.Row><Table.Col><Link to="KeywordAlert" params={{ id: item.id }}>{new Date(item.date).toLocaleDateString()}</Link></Table.Col></Table.Row>)}
    </Table.Body>
  </Table>
);

const KeywordsContainer = () => (
  <Container className="my-3">
    <Grid.Row>
      <Grid.Col lg={3}>
        <LocationSelect />
      </Grid.Col>
      <Grid.Col lg={9}>
        <Card>
          <AuthRedirect whenLoggedOut path="Home" />
          <Card.Header>Keyword alert emails are delivered every day at 9:30 EST</Card.Header>
          <Card.Body>
            <AddKeyword />
          </Card.Body>
        </Card>
        <Card>
          <Query query={keywords}>
            {({ loading, error, data }) => {
              if (loading) {
                return 'Loading...';
              }
              if (error) {
                return error.toString();
              }
              const userKeywords = data.userKeywords;
              return <ItemList keywords={userKeywords} />;
            }}
          </Query>
          {/* <AddKeyword /> */}
        </Card>
        <Card>
          <Query query={alertEmails}>
            {({ loading, error, data }) => {
              if (loading) {
                return 'Loading...';
              }
              if (error) {
                return error.toString();
              }
              const alerts = data.userKeywordAlerts;
              return <AlertEmail alerts={alerts} />;
            }}
          </Query>
        </Card>
      </Grid.Col>
    </Grid.Row>
  </Container>
);

export default KeywordsContainer;



// WEBPACK FOOTER //
// ./src/keywords/index.js